<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Configurazione" variant="outline-secondary" @click="onClickViewConfigurazioneMarcaArticolo(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Modifica Configurazione" variant="outline-success" @click="onClickEditConfigurazioneMarcaArticolo(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella Configurazione" variant="outline-danger" @click="onClickDeleteConfigurazioneMarcaArticolo(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>

                <configurazioni-magazzino-articoli-marca-modal-edit-component ref="cmpConfigurazioniMagazzinoArticoliMarcaModalEdit" @saveMarcaArticolo="loadDataMarcaArticoli" @marcaArticoloDelete="loadDataMarcaArticoli" @onCloseModal="loadDataMarcaArticoli" />
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioniMagazzinoArticoliMarcaModalEditComponent from "./ConfigurazioniMagazzinoArticoliMarcaModalEditComponent.vue";
export default {
    components: { ConfigurazioniMagazzinoArticoliMarcaModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            id: null,
            currentPage: 1,
            pathResource: "/magazzinoarticolimarche",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroConfigurazioniMarcheArticoli: { codiceAzienda: null, marca: null },
            fields: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 1rem",
                },
                {
                    label: "Codice Azienda",
                    key: "codiceAzienda",
                    sortable: false,
                },
                {
                    label: "Marca",
                    key: "marca",
                    sortable: false,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadDataMarcaArticoli();
        },
    },
    methods: {
        loadDataMarcaArticoli() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroMarcaArticolo"]) {
                me.filtroConfigurazioniMarcheArticoli = JSON.parse(sessionStorage["filtroMarcaArticolo"]);
                me.$emit("updateFilter", me.filtroConfigurazioniMarcheArticoli);
            }
            me.filtroConfigurazioniMarcheArticoli.page = me.currentPage;
            me.filtroConfigurazioniMarcheArticoli.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioniMarcheArticoli, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
        onClickViewConfigurazioneMarcaArticolo(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMarcaModalEdit.show(item, true);
        },
        onClickEditConfigurazioneMarcaArticolo(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMarcaModalEdit.show(item, false);
        },
        onNuovaMarcaArticolo() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMarcaModalEdit.show(
                {
                    id: null,
                    codiceAzienda: null,
                    marca: null,
                },
                false
            );
        },
        onClickDeleteConfigurazioneMarcaArticolo(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMarcaModalEdit.onDeleteMultiploArticolo(item);
        },
    },
};
</script>
